import React, { useEffect, useRef } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', isVisible, onClose, duration = 5000, stacked = false }) => {
  const timerRef = useRef(null);
  const onCloseRef = useRef(onClose);

  // Обновляем ref при изменении onClose
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    // Очищаем предыдущий таймер при любом изменении
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    // Устанавливаем таймер только когда всплывашка видима
    if (isVisible && duration > 0) {
      timerRef.current = setTimeout(() => {
        // Проверяем, что всплывашка все еще видима перед закрытием
        if (onCloseRef.current) {
          onCloseRef.current();
        }
      }, duration);
    }

    // Cleanup функция
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isVisible, duration]);

  const handleClick = () => {
    // Очищаем таймер при клике пользователя
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className={`toast toast-${type} ${stacked ? 'toast-stacked' : ''} ${isVisible ? 'toast-visible' : ''}`}>
      <div className="toast-content" onClick={handleClick}>
        <div className="toast-progress-bar" style={{ animationDuration: `${duration}ms` }}></div>
        <div className="toast-icon">
          {type === 'success' ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z" fill="currentColor"/>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 6V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M10 14H10.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
        <div className="toast-message">{message}</div>
      </div>
    </div>
  );
};

export default Toast;
